<div class="main-container">
  <div class="notification-header">
    <h1 style="font-size: 20px;">
      List Of Notifications 
      <span *ngIf="getUnreadCount() > 0" class="unread-badge">{{ getUnreadCount() }}</span>
    </h1>
    
    <div class="notification-actions" *ngIf="notifications.length > 0">
      <button 
        class="action-btn mark-read-btn" 
        [class.disabled]="!hasSelectedNotifications()" 
        (click)="markAsRead()"
        title="Mark as Read">
        <i class="fas fa-check"></i>
      </button>
      
      <button 
        class="action-btn delete-btn" 
        [class.disabled]="!hasSelectedNotifications()" 
        (click)="deleteNotifications()"
        title="Delete">
        <i class="fas fa-trash"></i>
      </button>
    </div>
  </div>

  <!-- Loading State -->
  <div *ngIf="loading && notifications.length === 0" class="loading-state">
    <div class="spinner"></div>
    <p>Loading notifications...</p>
  </div>

  <!-- Error State -->
  <div *ngIf="error && !loading" class="error-state">
    <i class="fas fa-exclamation-triangle"></i>
    <h3>{{ error }}</h3>
    <button class="retry-btn" (click)="loadNotifications()">Try Again</button>
  </div>

  <!-- Notifications List - FIXED: Use array instead of keyvalue pipe -->
  <ng-container *ngIf="notifications.length > 0; else emptyState">
    <div class="notification-list">
      <ng-container *ngFor="let dateGroup of getNotificationsByDate(); trackBy: trackByDateGroup">
        <div class="date-group">
          <h2 class="date-header">{{ dateGroup.key }} ({{ dateGroup.value.length }})</h2>
          
          <div class="notification-items">
            <div *ngFor="let notification of dateGroup.value; trackBy: trackByNotificationId" 
                 class="notification-item-inline" 
                 [class.unread]="!notification.isRead">
              
              <input type="checkbox" 
                     [checked]="isSelected(notification.id)" 
                     (change)="toggleSelection(notification.id)"
                     class="notification-checkbox">
              
              <!-- Avatar with proper profile image handling -->
              <div class="avatar" 
                   [style.background-color]="!hasValidProfileImage(notification) ? notification.avatarColor : 'transparent'">

                <!-- Show profile image if available (notification's own or account holder's) -->
                <img *ngIf="hasValidProfileImage(notification)" 
                     [src]="getProfileImageUrl(notification)" 
                     [alt]="notification.sender + ' profile'"
                     class="avatar-image"
                     (error)="onImageError($event, notification)">

                <!-- Fallback to initials only if no images are available -->
                <span *ngIf="!hasValidProfileImage(notification)" 
                      class="avatar-initials">
                  {{ getInitials(notification.sender) }}
                </span>

                <!-- Hidden fallback span for image error cases -->
                <span [id]="'fallback-' + notification.id"
                      class="avatar-fallback"
                      [style.background-color]="notification.avatarColor">
                  {{ getInitials(notification.sender) }}
                </span>
              </div>
              
              <div class="notification-content">
                <div class="notification-header-content">
                  <div class="notification-message">
                    <p [class.unread-text]="!notification.isRead">
                      <!-- Only show sender if it's not empty or "System" -->
                      <span *ngIf="shouldShowSender(notification.sender)" class="sender-name"></span>
                      {{ notification.message }}
                    </p>
                  </div>
                  <span class="notification-time">{{ notification.displayTime }}</span>
                </div>
                
                <!-- Show attachment if present (for document notifications) -->
                <div *ngIf="notification.attachment" class="attachment">
                  <i class="fas fa-paperclip"></i>
                  <span>{{ notification.attachment }}</span>
                </div>
              </div>
              
              <div *ngIf="!notification.isRead" class="unread-indicator"></div>
            </div>
          </div>
        </div>
      </ng-container>
    </div>
  </ng-container>
  
  <!-- Empty State Template -->
  <ng-template #emptyState>
    <div class="empty-state" *ngIf="!loading && !error">
      <div class="notification-bell-icon">
         <img src="assets/images/Group 1.png" alt="No notifications">
      </div>
      <h2>No Notifications Yet...</h2>
      <p>Stay informed with your latest updates<br>and alerts here.</p>
    </div>
  </ng-template>
</div>